import React, { useEffect, useState } from "react";
import NotificationDetailContent from "./components/NotificationDetailContent";
import NotificationDetailContext from "features/metadesk/Notification/NotificationDetail/NotificationDetail.context";
import useNotificationCenterState from "features/metadesk/Notification/NotificationDetail/NotificationDetail.hooks";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { apiUrl } from "features/configure";
import { enqueueSnackbar } from "features/common/redux/actions";
import { get } from "lodash-es";
import useNavigateEntity from "hooks/useNavigateEntity";

const NotificationDetailContainer = () => {
  const { formData, setFormData } = useNotificationCenterState();
  const { notificationId } = useParams();
  const dispatch = useDispatch();
  const [entityName] = useOutletContext();
  const [status, setStatus] = useState("draft");
  const { navigateEntity } = useNavigateEntity();
  const [loading, setLoading] = useState(false);
  const [initFinish, setInitFinish] = useState(false);

  const getDetail = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${apiUrl}/api/notification/${entityName}/${notificationId}`
      );
      setFormData(data);
      setStatus(data?.status);
      setInitFinish(true);
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: get(error, "response.data.error", "error"),
        })
      );
      navigateEntity("/notification/notification-center");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <div>
      <NotificationDetailContext.Provider value={{ formData, setFormData }}>
        {!loading && initFinish && (
          <NotificationDetailContent
            status={status}
          ></NotificationDetailContent>
        )}
      </NotificationDetailContext.Provider>
    </div>
  );
};

export default NotificationDetailContainer;
